<template>
  <div class="filterHeaderContainer">
    <div class="visuallyhidden" aria-label="Filter section for study results">
      <h1 id="filterSection">Filters</h1>
    </div>
    <div class="header row d-block d-md-none">
      <div class="text-right">
        <button aria-label="Close Filter Menu" class="btn btn--close d-md-none" @click="onClose">
          <div style="color: white; display: inline-block;">Close &ensp;</div> <i class="fa fa-times-circle"></i>
        </button>
      </div>
    </div>
    <!-- <span
      id="filterCount"
      aria-live="polite"
      aria-relevant="all"
      class="visuallyhidden"
      v-if="count"
      >{{ `${count}   ${$tc('plurals.filter', count)}   ${$t('ui.selected')}` | title }}</span
    > -->
  </div>
</template>

<script>
export default {
  props: { count: Number },
  data: () => ({}),
  methods: {
    onClose() {
      this.$store.commit('search/setShowFilterOnMobile', false)
      document.getElementById("toggle-filter-button").focus();
    },
  },
}
</script>


